module.exports = __webpack_public_path__ + "04_medium_black.e21dfa3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/04_medium_black.png
// module id = Y5Ib
// module chunks = 0